/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Simple/Data/format.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function StartAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Unstarted/Content/StartAction",
  onSubmit
  
}) {
let selectedQuickstartIdValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'quickstart_id',
format: fromFormat.not,
})
let selectedQuickstartIdSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginTop="auto"
 marginLeft={dtSpaceXs}
 data="selected.quickstart_id"
 format="/Simple/Data/format.js not"
 disabled={selectedQuickstartIdValueData}
 onClick={selectedQuickstartIdSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Start"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}